import { defineStore } from 'pinia'
import api from '@/api'

export const useMerchantDeviceStore = defineStore('merchantDevice', {
  state: () => ({
    merchantDevice: null,
    isBinding: false
  }),

  actions: {
    setMerchantDevice(merchantDevice) {
      this.merchantDevice = merchantDevice
    },

    /**
     * 获取当前设备详情
     */
    async getMerchantDeviceDetail() {
      try {
        const { data } = await api.merchantDevice.getMerchantDeviceDetail()
        this.setMerchantDevice(data.detail)
      } catch (e) {
        console.error('获取当前设备详情失败', e)
        throw e
      }
    }
  }
})
